import { useQuery } from '@hooks/reactQuery';

import { getRUConfigurationMiddlewares } from '@api/ruConfigurations';

import { mapDropdownOptions } from '@utils/formatter';

import { TIdSystemId } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_CONFIGURATIONS_MIDDLEWARES } from '@constants/queryKeys';

interface IUseQueryRUConfigurationMiddlewaresReturned {
	ruConfigurationMiddlewares: TSelectOption<string>[];
	isLoadingRUConfigurationMiddlewares: boolean;
}

export const useQueryRUConfigurationMiddlewares = (): IUseQueryRUConfigurationMiddlewaresReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<TIdSystemId[], TSelectOption<string>[]>({
		queryKey: [RU_CONFIGURATIONS_MIDDLEWARES],
		queryFn: getRUConfigurationMiddlewares,
		select: (data) => {
			return mapDropdownOptions({
				items: data,
				valueKey: 'id',
				labelKey: 'systemId',
			});
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		ruConfigurationMiddlewares: data || [],
		isLoadingRUConfigurationMiddlewares: isInitialLoading,
	};
};
